import React, { useEffect } from "react";
//import styles from "./Events.module.scss";
import Layout from "../../Layout/Main";
import EventsDailyList from "../../Components/Event/EventsDailyList/Index";
import HeadSEO from "../../Components/Head/Index";
import { componentFactory } from "../../Utils/ComponentsFactory";
import ComponentsUtils from "../../Utils/ComponentsUtils";
import { useRefreshProps } from "../../Hooks";
import { usePage } from "@inertiajs/react";
import DateUtils from "../../Utils/DateUtils";
import SEOUtils from "../../Utils/SEOUtils";

function Events(props) {
	const { page, locale, components, coreBannersAllPage, eventItemsDates, ziggy, userLogged } = props;
	const { url } = usePage();

	const componentMap = componentFactory();
	const zones = ["main", "asideTop", "asideMiddle", "asideBottom"];
	const FINAL_COMPONENTS = ComponentsUtils.getComponents(components, coreBannersAllPage, zones);

	{
		/** Aggiorna le props principali una volta ogni 5 minuti */
	}
	useEffect(() => {
		useRefreshProps(["components", "coreBannersAllPage", "eventItemsDates"], 300000);
	}, []);

	const urlObj = new URL(url, ziggy.url);
	const dateParam = urlObj.searchParams.get("date") || null;
	const eventsDailyListTitle = dateParam
		? `Eventi in data ${DateUtils.convertDateFromString(dateParam, false)}`
		: page?.header_title?.[locale]?.trim() || page?.title?.[locale]?.trim() || page?.name?.trim() || "Eventi";

	const main = (
		<>
			<EventsDailyList events={eventItemsDates} large={true} title={eventsDailyListTitle} />

			{/* Componenti main */}
			{FINAL_COMPONENTS.main?.map((componentObj, index) => {
				return ComponentsUtils.renderComponent(
					componentObj,
					componentMap,
					"",
					"main",
					undefined,
					<hr className="separatore"></hr>,
					userLogged
				);
			})}
		</>
	);

	const aside = (
		<>
			{/* Componenti asideTop */}
			{FINAL_COMPONENTS.asideTop?.map((componentObj, index) => {
				return ComponentsUtils.renderComponent(
					componentObj,
					componentMap,
					"",
					"asideTop",
					undefined,
					<hr className="separatore"></hr>,
					userLogged
				);
			})}
			{/* Componenti asideMiddle */}
			{FINAL_COMPONENTS.asideMiddle?.map((componentObj, index) => {
				return ComponentsUtils.renderComponent(
					componentObj,
					componentMap,
					"",
					"asideMiddle",
					undefined,
					<hr className="separatore"></hr>,
					userLogged
				);
			})}
			{/* Componenti asideBottom */}
			{FINAL_COMPONENTS.asideBottom?.map((componentObj, index) => {
				return ComponentsUtils.renderComponent(
					componentObj,
					componentMap,
					"",
					"asideBottom",
					undefined,
					<hr className="separatore"></hr>,
					userLogged
				);
			})}
		</>
	);

	const seoData = SEOUtils.generateSEOData({
		page: page,
		locale: locale,
		type: "events",
		ziggy: ziggy,
		otherProps: {
			title: eventsDailyListTitle,
			events: eventItemsDates,
		},
	});

	return (
		<>
			<HeadSEO data={seoData} />
			<Layout {...props} main={main} aside={aside} />
			{/** Componenti popup */}
			{ComponentsUtils.renderPopupComponents(FINAL_COMPONENTS.popup, componentMap)}
		</>
	);
}

export default Events;
